// ============================================================
// 📁 آدرس این فایل در پروژه (فایل جدید):
//    src/pages/tracking/geoPlaces.ts
//
// «فهرست داخلی شهرها، بندرها و مرزها» — بدون هیچ API و بدون اینترنت
//   • نام نزدیک‌ترین شهر به موقعیت موتر («نزدیک هرات، افغانستان»)
//   • پیدا کردن مختصات مبدأ/مقصد هر مرحله از روی همان متنی که شما نوشته‌اید
//   • نمایش نام شهرها روی نقشه حتی وقتی نقشه‌ی آنلاین بالا نیامده
// مختصات تقریبی است (برای برچسب‌گذاری)، نه نقشه‌ی دقیق شهری.
// ============================================================

export type Place = { fa: string; en: string; country: string; lat: number; lng: number; rank: 1 | 2 | 3; kind: "city" | "port" | "border"; keys: string[] };

// قالب: [نام فارسی و نام‌های دیگر با "|", نام انگلیسی, کشور, عرض, طول, رتبه(1 بزرگ..3 کوچک), نوع]
// نوع: c=شهر  p=بندر  b=مرز
type Row = [string, string, string, number, number, 1 | 2 | 3, "c" | "p" | "b"];

const ROWS: Row[] = [
  // ───── افغانستان ─────
  ["کابل|کابول", "Kabul", "افغانستان", 34.53, 69.17, 1, "c"],
  ["هرات", "Herat", "افغانستان", 34.35, 62.2, 1, "c"],
  ["قندهار|کندهار", "Kandahar", "افغانستان", 31.62, 65.72, 1, "c"],
  ["مزارشریف|مزار شریف|بلخ", "Mazar-i-Sharif", "افغانستان", 36.71, 67.11, 1, "c"],
  ["جلال‌آباد|جلال آباد|جلالآباد", "Jalalabad", "افغانستان", 34.43, 70.45, 1, "c"],
  ["کندز|قندوز", "Kunduz", "افغانستان", 36.73, 68.87, 2, "c"],
  ["غزنی", "Ghazni", "افغانستان", 33.55, 68.42, 2, "c"],
  ["بامیان", "Bamyan", "افغانستان", 34.82, 67.82, 2, "c"],
  ["زرنج", "Zaranj", "افغانستان", 30.96, 61.86, 2, "c"],
  ["فراه", "Farah", "افغانستان", 32.37, 62.11, 2, "c"],
  ["لشکرگاه|لشکر گاه", "Lashkar Gah", "افغانستان", 31.59, 64.37, 2, "c"],
  ["پلخمری|پل خمری", "Pul-e-Khumri", "افغانستان", 35.95, 68.71, 2, "c"],
  ["خوست", "Khost", "افغانستان", 33.34, 69.92, 2, "c"],
  ["فیض‌آباد|فیض آباد", "Faizabad", "افغانستان", 37.12, 70.58, 3, "c"],
  ["تالقان", "Taloqan", "افغانستان", 36.73, 69.53, 3, "c"],
  ["ایبک|آیبک", "Aybak", "افغانستان", 36.26, 68.02, 3, "c"],
  ["شبرغان", "Sheberghan", "افغانستان", 36.67, 65.75, 3, "c"],
  ["میمنه", "Maimana", "افغانستان", 35.92, 64.78, 3, "c"],
  ["قلعه نو|قلعه‌نو", "Qala-e-Naw", "افغانستان", 34.99, 63.13, 3, "c"],
  ["چغچران", "Chaghcharan", "افغانستان", 34.52, 65.25, 3, "c"],
  ["گردیز", "Gardez", "افغانستان", 33.6, 69.22, 3, "c"],
  ["چاریکار", "Charikar", "افغانستان", 35.01, 69.17, 3, "c"],
  ["سالنگ", "Salang", "افغانستان", 35.3, 69.03, 3, "c"],
  ["حیرتان", "Hairatan", "افغانستان", 37.24, 67.3, 2, "b"],
  ["اسلام قلعه|اسلام‌قلعه", "Islam Qala", "افغانستان", 34.66, 61.0, 2, "b"],
  ["تورخم|طورخم", "Torkham", "افغانستان", 34.11, 71.09, 2, "b"],
  ["سپین بولدک|اسپین بولدک|سپین‌بولدک", "Spin Boldak", "افغانستان", 31.0, 66.4, 2, "b"],
  ["تورغندی|طورغندی", "Torghundi", "افغانستان", 35.26, 62.28, 2, "b"],
  ["شیرخان بندر|شیر خان بندر", "Sher Khan Bandar", "افغانستان", 37.2, 68.7, 2, "b"],
  ["پنج پایان|پنجی پایان|نیژنی پنج", "Panji Poyon", "تاجیکستان", 37.2, 68.6, 3, "b"],
  // ───── ایران ─────
  ["تهران", "Tehran", "ایران", 35.69, 51.39, 1, "c"],
  ["بندرعباس|بندر عباس", "Bandar Abbas", "ایران", 27.18, 56.27, 1, "p"],
  ["چابهار|چابهار", "Chabahar", "ایران", 25.29, 60.64, 1, "p"],
  ["مشهد", "Mashhad", "ایران", 36.3, 59.6, 1, "c"],
  ["تبریز", "Tabriz", "ایران", 38.08, 46.29, 1, "c"],
  ["اصفهان", "Isfahan", "ایران", 32.65, 51.67, 1, "c"],
  ["شیراز", "Shiraz", "ایران", 29.59, 52.58, 1, "c"],
  ["زاهدان", "Zahedan", "ایران", 29.5, 60.86, 2, "c"],
  ["دوغارون|دوغارون", "Dogharoun", "ایران", 34.64, 60.98, 2, "b"],
  ["تایباد|تایباد", "Taybad", "ایران", 34.74, 60.78, 3, "c"],
  ["سرخس", "Sarakhs", "ایران", 36.54, 61.16, 2, "b"],
  ["میلک", "Milak", "ایران", 30.98, 61.8, 3, "b"],
  ["بازرگان", "Bazargan", "ایران", 39.39, 44.38, 2, "b"],
  ["امام خمینی|بندر امام|بندرامام", "Imam Khomeini Port", "ایران", 30.43, 49.07, 2, "p"],
  ["بوشهر", "Bushehr", "ایران", 28.97, 50.84, 2, "p"],
  ["اهواز", "Ahvaz", "ایران", 31.32, 48.67, 2, "c"],
  ["خرمشهر", "Khorramshahr", "ایران", 30.43, 48.18, 3, "p"],
  ["قم", "Qom", "ایران", 34.64, 50.88, 2, "c"],
  ["کرمان", "Kerman", "ایران", 30.28, 57.07, 2, "c"],
  ["یزد", "Yazd", "ایران", 31.9, 54.37, 2, "c"],
  ["کرمانشاه", "Kermanshah", "ایران", 34.31, 47.07, 2, "c"],
  ["ارومیه", "Urmia", "ایران", 37.55, 45.07, 2, "c"],
  ["قزوین", "Qazvin", "ایران", 36.27, 50.0, 3, "c"],
  ["رشت", "Rasht", "ایران", 37.28, 49.58, 3, "c"],
  ["بندر انزلی|انزلی", "Bandar Anzali", "ایران", 37.47, 49.46, 3, "p"],
  ["همدان", "Hamadan", "ایران", 34.8, 48.51, 3, "c"],
  ["بیرجند", "Birjand", "ایران", 32.87, 59.22, 3, "c"],
  ["سمنان", "Semnan", "ایران", 35.58, 53.39, 3, "c"],
  ["ساری", "Sari", "ایران", 36.56, 53.06, 3, "c"],
  ["ارومیه", "Urmia", "ایران", 37.55, 45.07, 3, "c"],
  ["جلفا", "Jolfa", "ایران", 38.94, 45.63, 3, "b"],
  ["پرویزخان", "Parvizkhan", "ایران", 34.46, 45.6, 3, "b"],
  ["مهران", "Mehran", "ایران", 33.12, 46.16, 3, "b"],
  // ───── ترکیه ─────
  ["استانبول", "Istanbul", "ترکیه", 41.01, 28.98, 1, "c"],
  ["آنکارا|انقره", "Ankara", "ترکیه", 39.93, 32.86, 1, "c"],
  ["ازمیر|إزمیر", "Izmir", "ترکیه", 38.42, 27.14, 1, "p"],
  ["مرسین|مرسین", "Mersin", "ترکیه", 36.8, 34.64, 1, "p"],
  ["اسکندرون|ایسکندرون", "Iskenderun", "ترکیه", 36.59, 36.17, 2, "p"],
  ["غازی عنتاب|گازی‌آنتپ|عنتاب|گازیانتپ", "Gaziantep", "ترکیه", 37.07, 37.38, 2, "c"],
  ["آدانا", "Adana", "ترکیه", 37.0, 35.32, 2, "c"],
  ["قونیه", "Konya", "ترکیه", 37.87, 32.49, 2, "c"],
  ["بورسا", "Bursa", "ترکیه", 40.19, 29.06, 2, "c"],
  ["قیصریه|قیصری", "Kayseri", "ترکیه", 38.73, 35.49, 2, "c"],
  ["طرابزون", "Trabzon", "ترکیه", 41.0, 39.72, 2, "p"],
  ["سامسون", "Samsun", "ترکیه", 41.29, 36.33, 2, "p"],
  ["ارزروم", "Erzurum", "ترکیه", 39.9, 41.27, 2, "c"],
  ["وان", "Van", "ترکیه", 38.5, 43.38, 2, "c"],
  ["آنتالیا", "Antalya", "ترکیه", 36.9, 30.71, 2, "c"],
  ["دیاربکر", "Diyarbakir", "ترکیه", 37.91, 40.24, 2, "c"],
  ["شانلی اورفا|اورفا", "Sanliurfa", "ترکیه", 37.16, 38.79, 3, "c"],
  ["گبزه|گبزه", "Gebze", "ترکیه", 40.8, 29.43, 3, "c"],
  ["ازمیت|ایزمیت", "Izmit", "ترکیه", 40.77, 29.94, 3, "c"],
  ["تکیرداغ", "Tekirdag", "ترکیه", 40.98, 27.51, 3, "p"],
  ["جیهان", "Ceyhan", "ترکیه", 37.02, 35.82, 3, "p"],
  ["علی‌آغا|علی آغا|آلیاغا", "Aliaga", "ترکیه", 38.8, 26.97, 3, "p"],
  ["ماردین", "Mardin", "ترکیه", 37.31, 40.74, 3, "c"],
  ["گوربلاک|گوربولاک", "Gürbulak", "ترکیه", 39.4, 44.38, 3, "b"],
  ["کاپیکوله", "Kapikule", "ترکیه", 41.72, 26.36, 3, "b"],
  ["سارپ", "Sarp", "ترکیه", 41.51, 41.55, 3, "b"],
  // ───── پاکستان ─────
  ["کراچی", "Karachi", "پاکستان", 24.86, 67.01, 1, "p"],
  ["پورت قاسم|بندر قاسم", "Port Qasim", "پاکستان", 24.77, 67.34, 2, "p"],
  ["لاهور", "Lahore", "پاکستان", 31.52, 74.36, 1, "c"],
  ["اسلام‌آباد|اسلام آباد", "Islamabad", "پاکستان", 33.68, 73.05, 1, "c"],
  ["پیشاور|پشاور", "Peshawar", "پاکستان", 34.01, 71.58, 1, "c"],
  ["کویته|کوئته", "Quetta", "پاکستان", 30.18, 66.99, 1, "c"],
  ["چمن", "Chaman", "پاکستان", 30.92, 66.45, 2, "b"],
  ["گوادر", "Gwadar", "پاکستان", 25.12, 62.32, 2, "p"],
  ["راولپندی", "Rawalpindi", "پاکستان", 33.6, 73.04, 3, "c"],
  ["ملتان", "Multan", "پاکستان", 30.2, 71.47, 3, "c"],
  ["فیصل‌آباد|فیصل آباد", "Faisalabad", "پاکستان", 31.42, 73.08, 3, "c"],
  ["حیدرآباد", "Hyderabad", "پاکستان", 25.39, 68.37, 3, "c"],
  ["واگه", "Wagah", "پاکستان", 31.6, 74.57, 3, "b"],
  ["تفتان", "Taftan", "پاکستان", 28.99, 61.57, 3, "b"],
  // ───── آسیای میانه ─────
  ["عشق‌آباد|عشق آباد|اشک‌آباد", "Ashgabat", "ترکمنستان", 37.95, 58.38, 1, "c"],
  ["ترکمن‌باشی|ترکمن باشی", "Turkmenbashi", "ترکمنستان", 40.02, 52.97, 2, "p"],
  ["مرو|ماری", "Mary", "ترکمنستان", 37.6, 61.83, 3, "c"],
  ["سرحدآباد|سرحد آباد|سرحدآباد", "Serhetabat", "ترکمنستان", 35.28, 62.35, 3, "b"],
  ["ترکمن‌آباد|ترکمن آباد", "Turkmenabat", "ترکمنستان", 39.07, 63.58, 3, "c"],
  ["تاشکند", "Tashkent", "ازبکستان", 41.3, 69.27, 1, "c"],
  ["ترمذ", "Termez", "ازبکستان", 37.22, 67.28, 2, "b"],
  ["سمرقند", "Samarkand", "ازبکستان", 39.65, 66.96, 2, "c"],
  ["بخارا", "Bukhara", "ازبکستان", 39.77, 64.42, 3, "c"],
  ["دوشنبه", "Dushanbe", "تاجیکستان", 38.56, 68.79, 1, "c"],
  ["آلماتی|الماتی", "Almaty", "قزاقستان", 43.24, 76.89, 1, "c"],
  ["آستانه|نورسلطان", "Astana", "قزاقستان", 51.17, 71.45, 2, "c"],
  ["آکتائو|اکتائو", "Aktau", "قزاقستان", 43.65, 51.15, 2, "p"],
  ["شیمکنت", "Shymkent", "قزاقستان", 42.32, 69.6, 3, "c"],
  ["خورگس", "Khorgos", "قزاقستان", 44.21, 80.41, 3, "b"],
  ["بیشکک", "Bishkek", "قرقیزستان", 42.87, 74.59, 2, "c"],
  // ───── قفقاز و روسیه ─────
  ["باکو", "Baku", "آذربایجان", 40.41, 49.87, 1, "p"],
  ["تفلیس", "Tbilisi", "گرجستان", 41.72, 44.79, 1, "c"],
  ["باتومی", "Batumi", "گرجستان", 41.65, 41.64, 2, "p"],
  ["پوتی", "Poti", "گرجستان", 42.15, 41.67, 3, "p"],
  ["ایروان", "Yerevan", "ارمنستان", 40.18, 44.51, 2, "c"],
  ["نخجوان", "Nakhchivan", "آذربایجان", 39.21, 45.41, 3, "c"],
  ["مسکو", "Moscow", "روسیه", 55.76, 37.62, 1, "c"],
  ["سن پترزبورگ|سنت پترزبورگ|سن‌پترزبورگ", "Saint Petersburg", "روسیه", 59.93, 30.34, 1, "p"],
  ["نووروسیسک|نووروسیسک", "Novorossiysk", "روسیه", 44.72, 37.77, 2, "p"],
  ["آستاراخان|استراخان", "Astrakhan", "روسیه", 46.35, 48.04, 2, "p"],
  ["کازان", "Kazan", "روسیه", 55.8, 49.11, 3, "c"],
  ["ولگوگراد", "Volgograd", "روسیه", 48.71, 44.51, 3, "c"],
  ["ماخاچ قلعه|ماخاچ‌قلعه", "Makhachkala", "روسیه", 42.98, 47.5, 3, "p"],
  // ───── عراق و خلیج فارس ─────
  ["بغداد", "Baghdad", "عراق", 33.31, 44.37, 1, "c"],
  ["بصره", "Basra", "عراق", 30.51, 47.78, 2, "p"],
  ["اربیل|هولیر", "Erbil", "عراق", 36.19, 44.01, 2, "c"],
  ["ام قصر|أم‌قصر", "Umm Qasr", "عراق", 30.03, 47.93, 3, "p"],
  ["دبی|دوبی", "Dubai", "امارات", 25.2, 55.27, 1, "p"],
  ["جبل علی|جبل‌علی", "Jebel Ali", "امارات", 25.01, 55.06, 2, "p"],
  ["شارجه", "Sharjah", "امارات", 25.35, 55.4, 2, "c"],
  ["ابوظبی|ابو ظبی", "Abu Dhabi", "امارات", 24.45, 54.38, 2, "c"],
  ["مسقط", "Muscat", "عمان", 23.59, 58.41, 2, "p"],
  ["صحار", "Sohar", "عمان", 24.35, 56.71, 3, "p"],
  ["دوحه", "Doha", "قطر", 25.29, 51.53, 3, "c"],
  ["کویت", "Kuwait City", "کویت", 29.38, 47.99, 3, "c"],
  ["ریاض", "Riyadh", "عربستان", 24.71, 46.68, 2, "c"],
  ["جده", "Jeddah", "عربستان", 21.54, 39.17, 2, "p"],
  ["دمام|دمّام", "Dammam", "عربستان", 26.43, 50.1, 3, "p"],
  // ───── هند، چین و سایر ─────
  ["بمبئی|ممبئی|مومبای", "Mumbai", "هند", 19.08, 72.88, 1, "p"],
  ["نهوا شیوا|جواهر لعل نهرو|جی ان پی تی", "Nhava Sheva", "هند", 18.95, 72.95, 2, "p"],
  ["موندرا", "Mundra", "هند", 22.84, 69.72, 2, "p"],
  ["کندلا", "Kandla", "هند", 23.03, 70.22, 3, "p"],
  ["دهلی نو|دهلی", "New Delhi", "هند", 28.61, 77.21, 1, "c"],
  ["امریتسر|آمریتسر", "Amritsar", "هند", 31.63, 74.87, 3, "c"],
  ["کلکته|کولکاتا", "Kolkata", "هند", 22.57, 88.36, 2, "p"],
  ["چنای|مدراس", "Chennai", "هند", 13.08, 80.27, 2, "p"],
  ["ارومچی|اورومچی", "Urumqi", "چین", 43.83, 87.62, 2, "c"],
  ["کاشغر", "Kashgar", "چین", 39.47, 75.99, 2, "c"],
  ["شانگهای", "Shanghai", "چین", 31.23, 121.47, 1, "p"],
  ["گوانگژو|کانتون", "Guangzhou", "چین", 23.13, 113.26, 1, "p"],
  ["تیانجین", "Tianjin", "چین", 39.34, 117.36, 2, "p"],
  ["نینگبو", "Ningbo", "چین", 29.87, 121.54, 2, "p"],
  ["شنژن", "Shenzhen", "چین", 22.54, 114.06, 2, "p"],
  ["پکن", "Beijing", "چین", 39.9, 116.4, 1, "c"],
  ["رتردام|روتردام", "Rotterdam", "هلند", 51.92, 4.48, 2, "p"],
  ["هامبورگ", "Hamburg", "آلمان", 53.55, 9.99, 2, "p"],
  ["پیرائوس|پیره", "Piraeus", "یونان", 37.94, 23.65, 3, "p"],
  ["اودسا", "Odesa", "اوکراین", 46.48, 30.73, 3, "p"],
  ["کنستانتا", "Constanta", "رومانی", 44.18, 28.65, 3, "p"],
  ["سنگاپور", "Singapore", "سنگاپور", 1.29, 103.85, 1, "p"],
  ["بندر کلانگ|پورت کلنگ", "Port Klang", "مالزی", 3.0, 101.39, 3, "p"],
  ["بانکوک", "Bangkok", "تایلند", 13.76, 100.5, 2, "c"],
  ["چاتوگرام|چیتاگونگ", "Chittagong", "بنگلادش", 22.34, 91.83, 3, "p"],
  ["قاهره", "Cairo", "مصر", 30.04, 31.24, 2, "c"],
  ["دمشق", "Damascus", "سوریه", 33.51, 36.29, 3, "c"],
  ["بیروت", "Beirut", "لبنان", 33.89, 35.5, 3, "p"],
  ["امان|عمان اردن", "Amman", "اردن", 31.95, 35.93, 3, "c"],
  ["عقبه", "Aqaba", "اردن", 29.53, 35.0, 3, "p"],
];

// ───── آماده‌سازی ─────
const norm = (s: string) =>
  String(s || "")
    .toLowerCase()
    .replace(/[يى]/g, "ی").replace(/ك/g, "ک").replace(/[ةۀ]/g, "ه").replace(/[أإآ]/g, "ا")
    .replace(/[ً-ٰٟ]/g, "")
    .replace(/[‌‍‎‏\s\-_.،,()]+/g, "");

const seen = new Set<string>();
export const PLACES: Place[] = [];
ROWS.forEach(r => {
  const names = r[0].split("|");
  const id = r[1] + "|" + r[2];
  if (seen.has(id)) return; seen.add(id);
  PLACES.push({ fa: names[0], en: r[1], country: r[2], lat: r[3], lng: r[4], rank: r[5], kind: r[6] === "p" ? "port" : r[6] === "b" ? "border" : "city", keys: [...names.map(norm), norm(r[1])].filter(Boolean) });
});

/** مکانی را که کاربر تایپ کرده پیدا می‌کند: «بندر عباس»، «مرز دوغارون»، «کارخانه‌ی مرسین»، «Herat» ... */
export function findPlace(text: string): Place | null {
  const q = norm(text);
  if (q.length < 2) return null;
  let best: Place | null = null, bestScore = 0;
  for (const p of PLACES) {
    for (const k of p.keys) {
      let sc = 0;
      if (q === k) sc = 1000 + k.length;
      else if (k.length >= 3 && q.includes(k)) sc = 100 + k.length;
      else if (q.length >= 4 && k.includes(q)) sc = 50 + q.length;
      if (sc > bestScore) { bestScore = sc; best = p; }
    }
  }
  return best;
}

export function distKm(aLat: number, aLng: number, bLat: number, bLng: number) {
  const R = 6371, rad = (x: number) => (x * Math.PI) / 180;
  const dLat = rad(bLat - aLat), dLng = rad(bLng - aLng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(aLat)) * Math.cos(rad(bLat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

/** نزدیک‌ترین مکان فهرست به یک نقطه */
export function nearestPlace(lat: number, lng: number): { p: Place; km: number } | null {
  let best: Place | null = null, bk = Infinity;
  for (const p of PLACES) { const d = distKm(lat, lng, p.lat, p.lng); if (d < bk) { bk = d; best = p; } }
  return best ? { p: best, km: bk } : null;
}

/** متن آماده: «در هرات، افغانستان» / «۴۲ km تا هرات، افغانستان» — اگر خیلی دور بود خالی */
export function placeText(lat: number, lng: number, maxKm = 300): string {
  const n = nearestPlace(lat, lng);
  if (!n || n.km > maxKm) return "";
  const nm = `${n.p.fa}${n.p.country ? "، " + n.p.country : ""}`;
  return n.km < 10 ? `در ${nm}` : `${Math.round(n.km)} km تا ${nm}`;
}

/** مکان‌های داخل یک کادر جغرافیایی، برای برچسب روی نقشه (بر اساس بزرگی نمایش) */
export function placesInBounds(south: number, west: number, north: number, east: number, zoom: number): Place[] {
  const maxRank = zoom >= 8 ? 3 : zoom >= 6 ? 2 : zoom >= 4 ? 1 : 0;
  if (!maxRank) return [];
  return PLACES.filter(p => p.rank <= maxRank && p.lat >= south && p.lat <= north && p.lng >= west && p.lng <= east).slice(0, 80);
}
